<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name {
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}
.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}
.input-item .input-title {
  margin-right: 14px;
}
.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}
.product-item {
  display: flex;
  margin-top: 10px;
}
.product {
  display: flex;
  align-items: center;
}
.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}
.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.server-task-Index .el-table__body-wrapper tr td:first-child{
  border-right: 0 none !important;
}
</style>
<template>
  <div class="content"  v-loading.fullscreen.lock="fullscreenLoading" >
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">公司名称</div>
          <el-select size="mini" class="ipt-sty" v-model="page.tenantGuid" filterable placeholder="请选择委托方" style="width: 260px">
            <el-option
              v-for="item in sendTenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">年度</div>
          <el-date-picker size="mini" v-model="page.planYear" type="year" format="yyyy年" placeholder="请选择年份" value-format="yyyy" >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box server-task-Index" :style="'height:' + contentMainHeight + 'px;'">
      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column  prop="tenantName"  width="265" label="公司名称"  show-overflow-tooltip header-align="center" align="left">
        </el-table-column>
        <el-table-column prop="planName" width="265" label="任务包名称" show-overflow-tooltip header-align="center" align="left">
        </el-table-column>
        <el-table-column prop="planYear" width="120" label="年度" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.planYear+'年度' }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" label="制定人" show-overflow-tooltip header-align="center" align="left">
        </el-table-column>
       
        
        <el-table-column prop="createTime" width="150" label="制定时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        
        <el-table-column prop="bank" width="80px" label="操作" header-align="center" align="center" >
          <template slot-scope="scope">
            <a class="txt-color" @click="see(scope.row.guid)">详情 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      contentMainHeight: window.innerHeight - 200,
      tableHeight: window.innerHeight - 220,
      textTitle: '新增任务大类',
      organisationList: [],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        currentTenantGuid:localStorage.guid,
        tenantGuid:'',
        planYear:'',
      },
      tenantList: [],
      sendTenantList:[],
      tableData: [],
    };
  },
  created() {
    this.getList();
    this.getSendTenantList();
  },
  activated(){
    this.getList();
  },
  watch: {
  },
  methods: {
    getSendTenantList() {
      let self = this;
      // let query = {
      //   isService: true,
      //   tenantGuid: localStorage.guid,
      // };
      let query ={
        'pageIndex':1,
        'pageSize':-1,
        'bizState':'Y',
        'enterpriseCates':this.$getValueListByKey('上游客户分类')
      }
      self.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/marketing-plan/list-servicer`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        currentTenantGuid:localStorage.guid,
        tenantGuid:'',
        planYear:'',
      };
      this.getList();
    },
    see(guid) {
      this.$router.push('/serverTaskDetail?guid=' + guid+'&productGuid='+this.$route.query.productGuid );
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/marketing-plan/list-servicer`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>